import { render, staticRenderFns } from "./AddMemberGroups.vue?vue&type=template&id=67760ce2&"
import script from "./AddMemberGroups.vue?vue&type=script&lang=js&"
export * from "./AddMemberGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports